// Types
import { ModalStoreState } from './useModalStore.types';

/**
 * Represents an initial state for the Dialoger.
 */
export const initialState: ModalStoreState = {
  isModalOpen: false,
  modalBody: null,
};
